import { render, staticRenderFns } from "./MedicalExamination.vue?vue&type=template&id=6bf08a4f&"
import script from "./MedicalExamination.vue?vue&type=script&lang=js&"
export * from "./MedicalExamination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports